/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import Bin from "../../assets/icons/Bin2.svg";
import Calendar2 from "../../assets/icons/Calendar3.svg";
import Clock from "../../assets/icons/Path 598.svg";
import PrintIcon from "../../assets/icons/Print icon.svg";
import Timer from "../../assets/icons/Timer.svg";
import Calendar from "../../assets/icons/calendar.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import Edit from "../../assets/icons/edit-3.svg";
import Lock from "../../assets/icons/lock.svg";
import searchicon from "../../assets/icons/search.svg";
import Cross from "../../assets/icons/x-circle-2.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import Loader from "../../components/Dailogs/Loader";
import Header from "../../layouts/Header";
import {
  CheckExistingTimeSession,
  CreateManualTimeSession,
  DeleteManualTimeSession,
  FetchProject,
  FetchProjectBB,
  GetUserTimeSession,
  UpdateManualTimeSession,
  fetchTaskByProject,
  FetchTasksWithOutProject,
} from "../../redux/actions/action";
import { generateCSV } from "../../utils/helpers/csvService";
import { convertToExcel } from "../../utils/helpers/excelService";
import { convertToPDF } from "../../utils/helpers/pdfService";
import "../../assets/styles/local/Worktime.css";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import { ROLES, isRole } from "../../utils/helpers/userRole";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Worktime = () => {
  const history = useHistory();
  const screenSize = useScreenSize();
  const [showModal, setShowModal] = useState(false);
  const [query, setQuery] = useState("");
  const userID = window.localStorage.getItem("userid");
  const companyId = window.localStorage.getItem("companyid");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Worktime-Tracking").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [over, setOver] = useState(false);
  const [userTimeSession, setUserTimeSession] = useState([]);
  const timeSession = useSelector((state) => state?.user?.userTimeSession);
  const fetchTaskWithoutProjectRes = useSelector(
    (state) => state?.user?.fetchTaskWithoutProjectRes,
  );
  const [selectedOption, setSelectedOption] = useState("Tracking");

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (option === "Report") {
      history.push("/worktime");
    }
  };

  const handleFetch = (page) => {
    setLoading(true);
    dispatch(GetUserTimeSession(userID, page)).then(() => {
      setLoading(false);
    });
  };
  useEffect(() => {
    handleFetch(page);
  }, [userID, page]);
  function filterInnerArray(searchString = "", dataArray = []) {
    return dataArray.map((week) => ({
      ...week,
      userWeeklyTaskList: week?.userWeeklyTaskList?.filter(
        (task) =>
          task?.description
            ?.toLowerCase()
            ?.includes(searchString?.toLowerCase()) ||
          task?.type?.toLowerCase()?.includes(searchString?.toLowerCase()) ||
          task?.taskName
            ?.toLowerCase()
            ?.includes(searchString?.toLowerCase()) ||
          task?.projectName
            ?.toLowerCase()
            ?.includes(searchString?.toLowerCase()),
      ),
    }));
  }
  useEffect(() => {
    if (timeSession && timeSession?.totalCount) {
      setUserTimeSession(timeSession?.data);
      if (page * 2 >= timeSession?.totalCount) {
        setOver(true);
      } else {
        setOver(false);
      }
    }
    if (query && query !== "") {
      const filteredData = filterInnerArray(query, timeSession?.data);
      setUserTimeSession(filteredData);
    }
  }, [timeSession, query]);
  const [showEditModalData, setShowEditModalData] = useState({
    projectTaskTrackingTimeid: "",
  });
  const handleCancelModal = () => {
    // setShowModal(false);
    setShowEditModalData({ projectTaskTrackingTimeid: "" });
  };
  const handleLatestWeek = () => {
    setPage(page + 1);
  };

  const handlePreviousWeek = () => {
    if (page === 1) {
      return;
    }
    setPage(page - 1);
  };
  function convertDecimalToTime(decimalValue = 0) {
    let hours = Math.floor(decimalValue);
    const minutes = (decimalValue - hours) * 60;
    if (hours < 10) {
      hours = `0${hours}`;
    }
    let min = Math.round(minutes);
    if (min < 10) {
      min = `0${min}`;
    }
    return `${hours}:${min}`;
  }
  const handleWorkingHour = (taskList = []) => {
    let hrs = 0;

    taskList?.forEach((task) => {
      const type = task?.type?.toLowerCase() || "";
      if (type === "work") {
        hrs = hrs + task?.totalHours || 0;
      }
    });

    return hrs;
  };

  // asc cancel popup start //
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    setCancelPopupShow(false);
    setShowModal(false);
    setTypeInScreen("");
  };
  const [typeInScreen, setTypeInScreen] = useState("");
  // asc cancel popup end //

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="flex-wrap gap-5 d-flex align-items-baseline">
            <div
              className="projectText2"
              onClick={() => {
                history.push("/worktime");
              }}
            >
              {/* Worktime */}
              {t("Worktime")}
            </div>
            {isRole(ROLES.MANAGER) || isRole(ROLES.OWNER) ? (
              <div
                className="projectText4"
                id="forWorkTime"
                style={{
                  background: "white",
                  padding: "5px",
                  border: "0.5px solid #e0dada",
                  borderRadius: "8px",
                }}
              >
                <button
                  className="btn dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    border: "none",
                    boxShadow: "none",
                    color: "#212529",
                  }}
                >
                  {selectedOption}
                </button>
                <ul
                  className="dropdown-menu pointer"
                  aria-labelledby="dropdownMenuButton1"
                  // style={{ top: "9px", left: "-6px" }}
                  style={{ inset: "7px auto auto -7px" }}
                >
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedOption === "Report" ? "active" : ""
                      }`}
                      onClick={() => handleOptionClick("Report")}
                    >
                      Report
                    </a>
                  </li>
                  <li>
                    <a
                      className={`dropdown-item ${
                        selectedOption === "Tracking" ? "active" : ""
                      }`}
                      onClick={() => handleOptionClick("Tracking")}
                    >
                      Tracking
                    </a>
                  </li>
                </ul>
              </div>
            ) : (
              <div className="projectText3" onClick={() => {}}>
                Tracking
              </div>
            )}
          </div>
        }
      />

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      {loading ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div
          className={`worktime-main-div ${
            screenSize === "xs" && "worktime-main-div-mobile"
          }`}
        >
          <div>
            {screenSize === "xs" ? (
              <div
                className="flex-wrap gap-5 d-flex align-items-baseline"
                style={{ justifyContent: "space-between" }}
              >
                <div
                  className="projectText2"
                  onClick={() => {
                    history.push("/worktime");
                  }}
                >
                  {/* Worktime */}
                  {t("Worktime")}
                </div>
                <div className="projectText3" onClick={() => {}}>
                  {/* Tracking */}
                  {t("Tracking")}
                </div>
              </div>
            ) : (
              <section className="worktime-btn-flex frc">
                <button
                  className="worktime-add-btn frc"
                  onClick={() => {
                    setShowModal(true);
                    setTypeInScreen("");
                  }}
                >
                  <img
                    alt=""
                    src={Timer}
                    style={{
                      width: "clamp(17.36px,1.271vw,1.271vw)",
                      height: "clamp(20px,1.464vw,1.464vw)",
                    }}
                  />
                  <p>
                    {/* Add Time */}
                    {t("Add Timer")}
                  </p>
                </button>
              </section>
            )}
            <div
              className={
                screenSize === "xs"
                  ? "worktime-content-container-mobile fc"
                  : "worktime-content-container fc"
              }
              style={{
                marginTop: screenSize === "xs" ? "30px" : "23px",
                marginBottom: screenSize === "xs" ? "130px" : "10px",
              }}
            >
              {userTimeSession?.map((timeSession) => {
                const weekStart = timeSession.weekStartDate?.split(" ")[0];
                const weekEnd = timeSession.weekEndDate?.split(" ")[0];
                return screenSize === "xs" ? (
                  <div className="worktime-week-container-mobile">
                    <section className="worktime-week-top-mobile">
                      <p
                        className="wt-16-bold"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {timeSession?.week}
                      </p>
                      <div className="frc wt-cal-dates">
                        <p
                          className="wt-16-regular"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {weekStart?.replaceAll("/", ".")} &nbsp; |&nbsp;{" "}
                          {weekEnd?.replaceAll("/", ".")}
                        </p>
                      </div>
                    </section>

                    <WeekSpace
                      handleFetch={handleFetch}
                      userTask={timeSession?.userWeeklyTaskList || []}
                      setShowModal={setShowModal}
                      setShowEditModalData={setShowEditModalData}
                      setFetchTranslationList={setFetchTranslationList}
                      FetchTranslationList={FetchTranslationList}
                    />
                  </div>
                ) : (
                  <div className="worktime-week-container">
                    <section className="worktime-week-top">
                      <p className="wt-16-bold">{timeSession?.week}</p>
                      <div className="frc wt-cal-dates">
                        <img
                          alt=""
                          src={Calendar}
                          style={{ width: "22px", height: "21px" }}
                        />
                        <p className="wt-16-regular">
                          {weekStart} - {weekEnd}
                        </p>
                      </div>
                      <p className="wt-16-semi">
                        {/* Total Week */}
                        {t("Total Week")}
                      </p>
                      <p className="wt-16-bold">
                        {convertDecimalToTime(
                          handleWorkingHour(
                            timeSession?.userWeeklyTaskList || [],
                          ),
                        )}
                      </p>
                    </section>

                    <WeekSpace
                      handleFetch={handleFetch}
                      userTask={timeSession?.userWeeklyTaskList || []}
                      setShowModal={setShowModal}
                      setShowEditModalData={setShowEditModalData}
                      setTypeInScreen={setTypeInScreen}
                      setFetchTranslationList={setFetchTranslationList}
                      FetchTranslationList={FetchTranslationList}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          {screenSize === "xs" ? (
            <div
              style={{
                position: "fixed",
                bottom: "0",
                marginBottom: "15px",
                width: "87%",
                background: "#fafafa",
              }}
            >
              {userTimeSession?.length > 0 && (
                <section
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px" }}>
                    <img
                      alt=""
                      src={Downarrow}
                      onClick={handlePreviousWeek}
                      style={{
                        marginTop: "3px",
                        width: "18px",
                        height: "12px",
                        transform: "rotate(90deg)",
                        cursor: "pointer",
                        opacity: page === 1 ? "50%" : "100%",
                        pointerEvents: page === 1 ? "none" : "all",
                      }}
                    />
                    <p className="previous-week-text">
                      {/* Present Week */}
                      {t("Current Week")}
                    </p>
                  </div>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <p className="present-week-text">
                      {/* Previous Week */}
                      {t("Previous Week")}
                    </p>
                    <img
                      alt=""
                      src={Downarrow}
                      onClick={handleLatestWeek}
                      style={{
                        width: "18px",
                        marginTop: "3px",
                        height: "12px",
                        transform: "rotate(-90deg)",
                        cursor: "pointer",
                        opacity: over ? "50%" : "100%",
                        pointerEvents: over ? "none" : "all",
                      }}
                    />
                  </div>
                </section>
              )}
              <div style={{ width: "100%" }}>
                <button
                  style={{ width: "100%" }}
                  className="worktime-add-btn frc"
                  onClick={() => setShowModal(true)}
                >
                  <img
                    alt=""
                    src={Timer}
                    style={{
                      width: "clamp(17.36px,1.271vw,1.271vw)",
                      height: "clamp(20px,1.464vw,1.464vw)",
                    }}
                  />
                  <p>
                    {/* Add Time */}
                    {t("Add Time")}
                  </p>
                </button>
              </div>
            </div>
          ) : (
            userTimeSession?.length > 0 && (
              <section className="frc worktime-page-sec">
                <p className="previous-week-text">
                  {/* Current Week */}
                  {t("Current Week")}
                </p>
                <img
                  alt=""
                  src={Downarrow}
                  onClick={handlePreviousWeek}
                  style={{
                    width: "12px",
                    height: "7px",
                    transform: "rotate(90deg)",
                    cursor: "pointer",
                    opacity: page === 1 ? "50%" : "100%",
                    pointerEvents: page === 1 ? "none" : "all",
                  }}
                />
                <img
                  alt=""
                  src={Downarrow}
                  onClick={handleLatestWeek}
                  style={{
                    width: "12px",
                    height: "7px",
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    opacity: over ? "50%" : "100%",
                    pointerEvents: over ? "none" : "all",
                  }}
                />
                <p className="present-week-text">
                  {/* Previous Week */}
                  {t("Previous Week")}
                </p>
              </section>
            )
          )}
        </div>
      )}
      {showModal && (
        <WorkTimeModal
          handleFetch={handleFetch}
          showModal={showModal}
          handleCancelModal={handleCancelModal}
          projectTaskTrackingTimeid={
            showEditModalData?.projectTaskTrackingTimeid
          }
          editData={showEditModalData}
          typeInScreen={typeInScreen}
          setTypeInScreen={setTypeInScreen}
          setCancelPopupShow={setCancelPopupShow}
          setShowModal={setShowModal}
          fetchTaskWithoutProjectRes={fetchTaskWithoutProjectRes}
          setFetchTranslationList={setFetchTranslationList}
          FetchTranslationList={FetchTranslationList}
        />
      )}
    </>
  );
};

export default Worktime;

const WeekSpace = ({
  userTask,
  setShowModal,
  setShowEditModalData,
  handleFetch,
  setTypeInScreen,
  FetchTranslationList,
}) => {
  const [loading, setLoading] = useState(false);
  const t = (key) => FetchTranslationList?.[key] || "";
  const handleDelete = (projectTaskTrackingTimeid) => {
    const craftedData = {
      projectTaskTrackingTimeid: projectTaskTrackingTimeid,
      isDeleted: 1,
    };
    setLoading(true);
    DeleteManualTimeSession(craftedData)
      .then(() => {
        setLoading(false);
        handleFetch();
      })
      .catch(() => {
        setLoading(false);
      });
  };
  function convertDecimalToTime(decimalValue = 0) {
    let hours = Math.floor(decimalValue);
    const minutes = (decimalValue - hours) * 60;
    if (hours < 10) {
      hours = `0${hours}`;
    }
    let min = Math.round(minutes);
    if (min < 10) {
      min = `0${min}`;
    }
    return `${hours}:${min}`;
  }
  const handleWorkingHour = (taskList = []) => {
    let hrs = 0;

    taskList?.forEach((task) => {
      const type = task?.type?.toLowerCase() || "";
      if (type === "work") {
        hrs = hrs + task?.totalHours || 0;
      }
    });

    return hrs;
  };
  const handleSinglePrint = async (report, format) => {
    switch (format) {
      case "pdf":
        convertToPDF(report, "worktime");
        break;
      case "csv":
        generateCSV(report, "worktime");
        break;
      case "xlsx":
        convertToExcel(report, "worktime");
        break;
      default:
        alert("Unsupported file format");
    }
  };
  const screenSize = useScreenSize();

  return screenSize === "xs" ? (
    <>
      <div className="wt-space-container">
        <section
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginLeft: "10px",
            marginRight: "10px",
            paddingTop: "30px",
            borderBottom: "1px dashed rgba(0, 0, 0, 0.5)",
          }}
        >
          <p style={{ fontWeight: "bold" }}>
            {/* Total Week */}
            {t("Total Week")}
          </p>
          <p style={{ fontWeight: "bold" }}>
            {convertDecimalToTime(handleWorkingHour(userTask))}
          </p>
        </section>

        {userTask?.map((task) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "94%",
                paddingTop: "10px",
                paddingBottom: "10px",
                marginLeft: "10px",
                marginRight: "20px",
                borderBottom: "1px dashed rgba(0, 0, 0, 0.5)",
              }}
            >
              <p className="wt-space-content-text ">
                {task?.trackerStartDate?.slice(0, -5)?.replaceAll("/", ".") ||
                  ""}
              </p>
              <div style={{ display: "flex" }}>
                <p
                  className="wt-space-content-text ellipse"
                  onClick={() => {
                    setShowModal(true);
                    setShowEditModalData({
                      projectTaskTrackingTimeid: task.projectTaskTrackingTimeid,
                      projectname: task?.projectName,
                      taskname: task?.taskName,
                      type: task?.type,
                      description: task?.description,
                      totalHours: task?.totalHours,
                      trackerEndTime: task?.trackerEndTime,
                      trackerStartDate: task?.trackerStartDate,
                      trackerStartTime: task?.trackerStartTime,
                    });
                  }}
                >
                  {task?.projectName?.length > 25
                    ? task?.projectName?.slice(0, 25) + "..."
                    : task?.projectName || ""}
                </p>
              </div>
              <div>
                <p className="wt-space-content-text">
                  {convertDecimalToTime(task?.totalHours)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  ) : (
    <>
      <div className="wt-space-container">
        <section className="wt-space-head">
          <p className="wt-space-head-text">
            {/* Day */}
            {t("Day")}
          </p>
          <article className="wt-space-head-grid-1">
            <p className="wt-space-head-text">
              {/* Type */}
              {t("TYPE")}
            </p>
            <p className="wt-space-head-text">
              {/* Project */}
              {t("Project")}
            </p>
            <p className="wt-space-head-text">
              {/* Task */}
              {t("Task")}
            </p>
          </article>
          <p className="wt-space-head-text">
            {/* Time */}
            {t("Time")}
          </p>
          <article className="frc wt-space-head-desc">
            <p className="wt-space-head-text">
              {/* Task Description */}
              {t("Task Description")}
            </p>
            <article className="frc" style={{ gap: "10px" }}>
              <div className="dropdown" style={{ backgroundColor: "#FAFAFA" }}>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "end",
                  }}
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={PrintIcon}
                    style={{ padding: "0 10px" }}
                    alt="Print Icon"
                  />
                  {/* Print */}
                  {t("Print")}
                </div>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => handleSinglePrint(userTask, "pdf")}
                    >
                      {/* Download as PDF */}
                      {t("Download as PDF")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => handleSinglePrint(userTask, "xlsx")}
                    >
                      {/* Download as Excel */}
                      {t("Download as Excel")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      onClick={() => handleSinglePrint(userTask, "csv")}
                    >
                      {/* Download as CSV */}
                      {t("Download as CSV")}
                    </a>
                  </li>
                </ul>
              </div>
            </article>
          </article>
        </section>
        <div className="wt-space-line"></div>

        {userTask?.map((task) => {
          return (
            <div className="wt-space-head" style={{ paddingTop: "0" }}>
              <p className="wt-space-content-text ellipse">
                {task?.trackerStartDate || ""}
              </p>
              <article className="wt-space-head-grid-1">
                <p className="wt-space-content-text ellipse">
                  {task?.type || ""}
                </p>
                <p className="wt-space-content-text ellipse">
                  {task?.projectName?.length > 35
                    ? task?.projectName?.slice(0, 35) + "..."
                    : task?.projectName || ""}
                </p>
                <p className="wt-space-content-text ellipse">
                  {task?.taskName?.length > 35
                    ? task?.taskName?.slice(0, 35) + "..."
                    : task?.taskName || ""}
                </p>
              </article>
              <p className="wt-space-content-text ellipse">
                {convertDecimalToTime(task?.totalHours)}
              </p>
              <article
                className="frc wt-space-head-desc"
                style={{ height: "fit-content" }}
              >
                <p className="wt-space-content-text ellipse">
                  {task?.description?.length > 40
                    ? task?.description?.slice(0, 40) + "..."
                    : task?.description || ""}
                </p>
                <article className="fr" style={{ height: "22px", gap: "25px" }}>
                  <img
                    alt=""
                    src={Edit}
                    onClick={() => {
                      setShowModal(true);
                      setShowEditModalData({
                        projectTaskTrackingTimeid:
                          task.projectTaskTrackingTimeid,
                        projectname: task?.projectName,
                        taskname: task?.taskName,
                        type: task?.type,
                        description: task?.description,
                        totalHours: task?.totalHours,
                        trackerEndTime: task?.trackerEndTime,
                        trackerStartDate: task?.trackerStartDate,
                        trackerStartTime: task?.trackerStartTime,
                      });
                      setTypeInScreen("");
                    }}
                    style={{
                      width: "17px",
                      height: "16.24px",
                      cursor: "pointer",
                    }}
                  />
                  <img
                    alt=""
                    src={Bin}
                    onClick={() => {
                      handleDelete(task.projectTaskTrackingTimeid);
                    }}
                    style={{
                      width: "16.34px",
                      height: "18px",
                      cursor: "pointer",
                    }}
                  />
                </article>
              </article>
            </div>
          );
        })}
      </div>
    </>
  );
};

const WeekSpaceApproved = () => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Worktime-Report").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <div className="wt-space-container">
      <section className="wt-space-head">
        <p className="wt-space-head-text">
          {/* Day */}
          {t("Day")}
        </p>
        <article className="wt-space-head-grid-1">
          <p className="wt-space-head-text">
            {/* Type */}
            {t("Type")}
          </p>
          <p className="wt-space-head-text">
            {/* Project */}
            {t("Project")}
          </p>
          <p className="wt-space-head-text">
            {/* Task */}
            {t("Task")}
          </p>
        </article>
        <p className="wt-space-head-text">
          {/* Time */}
          {t("Time")}
        </p>
        <article className="frc wt-space-head-desc">
          <p className="wt-space-head-text">
            {/* Task Description */}
            {t("Task Description")}
          </p>
          <article className="frc" style={{ gap: "10px" }}>
            <img src={PrintIcon} style={{ height: "18px", width: "18px" }} />
            <p className="wt-space-print-text">
              {/* Print */}
              {t("Print")}
            </p>
          </article>
        </article>
      </section>
      <div className="wt-space-line"></div>
      <div className="wt-space-head" style={{ paddingTop: "0" }}>
        <p className="wt-space-content-text ellipse">25.04.2023</p>
        <article className="wt-space-head-grid-1">
          <p className="wt-space-content-text ellipse">
            {/* Work */}
            {t("Work")}
          </p>
          <p className="wt-space-content-text ellipse">
            2022|00102-A Lorum ipsis …
          </p>
          <p className="wt-space-content-text ellipse">05 - Bouwplaatskosten</p>
        </article>
        <p className="wt-space-content-text ellipse">4:05</p>
        <article
          className="frc wt-space-head-desc"
          style={{ height: "fit-content" }}
        >
          <p className="wt-space-content-text ellipse">
            {/* Task name and description of the action */}
            {t("Task name and description of the action")}
          </p>
          <article className="fr" style={{ height: "22px", gap: "25px" }}>
            <img src={Lock} style={{ width: "13.62px", height: "15px" }} />
          </article>
        </article>
      </div>
    </div>
  );
};

const WorkTimeModal = ({
  showModal,
  handleCancelModal,
  projectTaskTrackingTimeid = "",
  editData,
  handleFetch,
  typeInScreen,
  setTypeInScreen,
  setShowModal,
  setCancelPopupShow,
  fetchTaskWithoutProjectRes,
  FetchTranslationList,
}) => {
  const isEdit =
    projectTaskTrackingTimeid && projectTaskTrackingTimeid?.trim() !== "";
  const [showTypeDrop, setShowTypeDrop] = useState(false);
  const [activeProjectDrop, setActiveProjectDrop] = useState(false);
  const [activeTaskDrop, setActiveTaskDrop] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");
  const [taskSearch, setTaskSearch] = useState("");
  const [description, setDescription] = useState("");
  const [day, setDay] = useState(new Date());
  const userID = window.localStorage.getItem("userid");
  const [loading, setLoading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const screenSize = useScreenSize();
  const t = (key) => FetchTranslationList?.[key] || "";

  const dispatch = useDispatch();
  const companyId = window.localStorage.getItem("companyid");
  const fetchProject = useSelector((state) => state.user.fetchProject);
  const fetchProjectBB = useSelector((state) => state.user.fetchProjectBB);
  const fetchProjectTasks = useSelector(
    (state) => state.user.fetchProjectTasks,
  );
  const [fromHour, setFromHour] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [total, setTotal] = useState("00:00");
  const [fromMinute, setFromMinute] = useState("");
  const [toHour, setToHour] = useState("");
  const [toMinute, setToMinute] = useState("");
  const [totalMinute, setTotalMinute] = useState("00");
  const [totalHour, setTotalHour] = useState("00");
  const [data, setData] = useState({ type: "Work" });
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);
  useEffect(() => {
    if (editData && editData?.trackerStartDate) {
      const from = editData?.trackerStartTime?.split(":");
      const to = editData?.trackerEndTime?.split(":");
      const [day, month, year] = editData?.trackerStartDate?.split("/");
      const dateObject = new Date(`${year}-${month}-${day}`);
      setDay(dateObject);
      setData({
        taskname: editData?.taskname,
        projectName: editData?.projectname,
        description: editData?.description,
        type: editData?.type || "",
      });
      setFromHour(from?.[0] || "00");
      setFromMinute(from?.[1] || "00");
      setToHour(to?.[0] || "00");
      setToMinute(to?.[1] || "00");
      setFrom((from?.[0] || "00") + ":" + (from?.[1] || "00"));
      setTo((to?.[0] || "00") + ":" + (to?.[1] || "00"));
      setDescription(editData?.description || "");
    }
  }, [editData]);

  useEffect(() => {
    if (!editData) {
      setFromMinute("00");
    }
  }, [fromHour]);
  useEffect(() => {
    if (!editData) {
      setToMinute("00");
    }
  }, [toHour]);

  useEffect(() => {
    const handleSearch = () => {
      const filteredProjects = projects?.filter((project) =>
        project?.projectname
          ?.toLowerCase()
          ?.includes(projectSearch?.toLowerCase()),
      );
      const filteredTasks = fetchProjectTasks?.data?.filter((task) =>
        task?.taskname?.toLowerCase()?.includes(taskSearch?.toLowerCase()),
      );
      setProjects(filteredProjects);
      // setTasks(filteredTasks);
    };
    if (projectSearch.trim() !== "" || taskSearch.trim() !== "") {
      handleSearch();
    } else {
      if (projectSearch.trim() === "") {
        if (isBuildingBlock) {
          setProjects(processProjectData(fetchProjectBB));
        } else {
          setProjects(processProjectData(fetchProject));
        }
        if (fetchProjectTasks?.status === true) {
          setTasks(fetchProjectTasks?.data);
        }
      }
      if (taskSearch.trim() === "") {
        if (fetchProjectTasks?.status === true) {
          setTasks(fetchProjectTasks?.data);
        }
      }
    }
  }, [projectSearch, taskSearch]);

  const searchTask = (searchObj) => {
    setTaskSearch(searchObj.target.value);
    console.log(searchObj.target.value);
    let searchStr = searchObj.target.value;
    if (!searchStr) {
      setTasks(JSON.parse(JSON.stringify(masterTasks)));
    } else {
      searchStr = searchStr.trim();

      let filteredTasks = masterTasks.filter((task) =>
        task?.taskname?.toLowerCase()?.includes(searchStr.toLowerCase()),
      );
      setTasks(filteredTasks);
    }
  };

  const calculateTotalTimes = (hour, minute) => {
    return parseInt(hour, 10) * 60 + parseInt(minute, 10);
  };

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time.toString();
  };

  const calculateAndSetTotal = () => {
    const fromTime = calculateTotalTimes(fromHour || "00", fromMinute || "00");
    const toTime = calculateTotalTimes(toHour || "00", toMinute || "00");

    if (toTime >= fromTime) {
      const totalTimeInMinutes = toTime - fromTime;
      const totalHours = Math.floor(totalTimeInMinutes / 60);
      const totalMinutes = totalTimeInMinutes % 60;

      const formattedHours = formatTime(totalHours);
      const formattedMinutes = formatTime(totalMinutes);

      setTotal(`${formattedHours}:${formattedMinutes}`);
      setTotalHour(formattedHours);
      setTotalMinute(formattedMinutes);
    } else {
      setTotalHour("00");
      setTotalMinute("00");
    }
  };
  const calculateTotalTime = () => {
    if (screenSize === "xs") {
      const fromTime =
        parseInt(fromHour || "00", 10) * 60 + parseInt(fromMinute || "00", 10);
      const toTime =
        parseInt(toHour || "00", 10) * 60 + parseInt(toMinute || "00", 10);
      if (toTime >= fromTime) {
        const totalTimeInMinutes = toTime - fromTime;
        const totalHours = Math.floor(totalTimeInMinutes / 60);
        const totalMinutes = totalTimeInMinutes % 60;
        const formattedHours =
          totalHours < 10 ? `0${totalHours}` : totalHours.toString();
        const formattedMinutes =
          totalMinutes < 10 ? `0${totalMinutes}` : totalMinutes.toString();
        setTotalHour(formattedHours);
        setTotalMinute(formattedMinutes);
      } else {
        setTotalHour("00");
        setTotalMinute("00");
      }
    } else {
      calculateAndSetTotal();
    }
  };

  const validate = () => {
    if (!data?.taskname || data?.taskname?.trim() === "") {
      setIsSubmitDisabled(true);
      return;
    }
    if (!data?.type || data?.type?.trim() === "") {
      setIsSubmitDisabled(true);
      return;
    }
    if (screenSize === "xs" && totalHour === "00" && totalMinute === "00") {
      setIsSubmitDisabled(true);
      return;
    }
    if (
      screenSize !== "xs" &&
      total?.split(":")?.[0] === "00" &&
      total?.split(":")?.[1] === "00"
    ) {
      setIsSubmitDisabled(true);
      return;
    }
    if (
      screenSize !== "xs" &&
      (total?.split(":")?.[0] === undefined ||
        total?.split(":")?.[1] === undefined)
    ) {
      setIsSubmitDisabled(true);
      return;
    }
    setIsSubmitDisabled(false);
  };
  useEffect(() => {
    validate();
  }, [totalHour, totalMinute, data, total]);

  useEffect(() => {
    calculateTotalTime();
  }, [fromHour, fromMinute, toHour, toMinute, from, to]);

  useEffect(() => {
    const fetchData = async () => {
      let fetchAction;
      if (isBuildingBlock) {
        fetchAction = FetchProjectBB(
          companyId,
          "",
          process.env.REACT_APP_IS_PREMIUM,
        );
      } else {
        fetchAction = FetchProject(companyId);
      }

      try {
        await dispatch(fetchAction);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [isBuildingBlock, companyId, dispatch]);

  useEffect(() => {
    if (data?.projectId && data?.projectId?.trim() !== "") {
      dispatch(fetchTaskByProject(data?.projectId));
    }
  }, [data?.projectId]);

  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [masterTasks, setMasterTasks] = useState([]);

  const processProjectData = (data) =>
    data?.data &&
    data.status === true &&
    data.data[0] &&
    data.data[0].projectstatus &&
    Array.isArray(data.data[0].projectstatus)
      ? data.data[0].projectstatus.flatMap(
          (status) => status.projectdetails || [],
        )
      : [];

  useEffect(() => {
    if (isBuildingBlock) {
      setProjects(processProjectData(fetchProjectBB));
    } else {
      setProjects(processProjectData(fetchProject));
    }
  }, [
    fetchProjectBB,
    fetchProject,
    isBuildingBlock,
    fetchProjectBB?.data,
    fetchProject?.data,
  ]);

  useEffect(() => {
    if (fetchProjectTasks?.status === true) {
      setTasks(fetchProjectTasks?.data);
      setMasterTasks(fetchProjectTasks?.data);
    }
  }, [fetchProjectTasks]);

  const [conflict, setConflict] = useState({
    isConflict: false,
    conflictMessage: "",
  });
  const handleAddManualTime = async () => {
    const dateObj = new Date(day);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const date = dateObj.getDate().toString().padStart(2, "0");
    const formattedDate = `${date}/${month}/${year}`;

    // let from_submit = fromHour + ":" + fromMinute + ":00";
    // let to_submit = toHour + ":" + toMinute + ":00";

    let from_submit = `${fromHour}${fromMinute ? ":" + fromMinute : ":00"}:00`;
    let to_submit = `${toHour}${toMinute ? ":" + toMinute : ":00"}:00`;

    const hourInt = parseInt(totalHour, 10);

    const minuteInt = parseInt(totalMinute, 10);

    let totalTime = hourInt + minuteInt / 60;
    // if (screenSize === "xs") {
    //   from_submit = from + ":00"
    //   to_submit = to + ":00"
    //   totalTime = parseInt(total?.split(":")?.[0]) + parseInt(total?.split(":")?.[1]) / 60;
    // }
    const formattedTime = totalTime?.toFixed(2);

    const craftedData = {
      projectId: data?.projectId ? data?.projectId : null,
      taskid: data?.taskid,
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      TotalTrackedTime: formattedTime,
      type: data?.type || "Work",
      description: description,
      isManual: 0,
      userid: userID,
    };
    const craftedDataForEdit = {
      projectTaskTrackingTimeid: projectTaskTrackingTimeid || "",
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      TotalTrackedTime: formattedTime,
      type: data?.type || "Work",
      description: description,
    };
    setLoading(true);
    await CheckExistingTimeSession({
      trackerStartDate: formattedDate,
      trackerStartTime: from_submit,
      trackerEndDate: formattedDate,
      trackerEndTime: to_submit,
      userid: userID,
    }).then((data) => {
      setConflict({
        isConflict: !data?.data?.status,
        conflictMessage: data?.data?.message || "",
      });
      if (data?.data?.status) {
        if (isEdit) {
          UpdateManualTimeSession(craftedDataForEdit)
            .then(() => {
              setLoading(false);
              setShowModal(false);
              handleCancelModal();
              handleFetch();
            })
            .catch(() => {
              setLoading(false);
            });
        } else {
          CreateManualTimeSession(craftedData)
            .then(() => {
              setLoading(false);
              setShowModal(false);
              handleCancelModal();
              handleFetch();
            })
            .catch(() => {
              setLoading(false);
            });
        }
      } else {
        setLoading(false);
      }
    });
  };

  const [dateError, setDateError] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  // asc fetchTaskWithoutProject res start.
  useEffect(() => {
    dispatch(FetchTasksWithOutProject(companyId));
  }, []);

  const [taskWithoutProjectData, setTaskWithoutProjectData] = useState([]);
  useEffect(() => {
    if (fetchTaskWithoutProjectRes.status === true) {
      // setTaskWithoutProjectData(fetchTaskWithoutProjectRes.data);
      setTasks(fetchTaskWithoutProjectRes.data);
      setMasterTasks(fetchTaskWithoutProjectRes.data);
    }
  }, [fetchTaskWithoutProjectRes]);
  // asc fetchTaskWithoutProject res end.

  return (
    <>
      <div className="wt-modal-background">
        <div className="wt-mdoal-div">
          <section className="wt-modal-top-sec">
            <p className="wt-modal-top-text">
              {isEdit ? "Edit" : "Add"}
              {/* Time */}
              {t("Time")}
            </p>
          </section>
          <section className="wt-modal-bottom-sec">
            <p className="wt-modal-light-text">TYPE</p>
            <article className="wt-modal-work-flex frc">
              <p
                className="wt-space-content-text"
                style={{ flexGrow: "1" }}
                onClick={() => {
                  setShowTypeDrop(!showTypeDrop);
                  setActiveProjectDrop(false);
                  setActiveTaskDrop(false);
                }}
              >
                {data?.type?.trim() === "" || !data?.type
                  ? isEdit
                    ? data?.type || ""
                    : "Work"
                  : data.type}
              </p>
              <img
                alt=""
                src={Cross}
                style={{ width: "8px", height: "8px", flexShrink: "0" }}
                onClick={() => {
                  setShowTypeDrop(!showTypeDrop);
                  setActiveProjectDrop(false);
                  setActiveTaskDrop(false);
                }}
              />
              {showTypeDrop && (
                <article className="wt-modal-work-drop fc">
                  <img
                    alt=""
                    src={Downarrow}
                    className="wt-modal-down-btn"
                    onClick={() => setShowTypeDrop(false)}
                  />
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type?.trim() === "" || !data?.type
                        ? ""
                        : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Work" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Work */}
                    {t("Work")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Sick" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Sick" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Sick */}
                    {t("Sick")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Holiday" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Holiday" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Holiday */}
                    {t("Holiday")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Vacation" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Vacation" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Vacation */}
                    {t("Vacation")}
                  </p>
                  <p
                    className={`wt-modal-selected-text ${
                      data?.type === "Other" ? "" : "unselected"
                    }`}
                    onClick={() => {
                      setData({ ...data, type: "Other" });
                      setShowTypeDrop(false);
                    }}
                  >
                    {/* Other */}
                    {t("Other")}
                  </p>
                </article>
              )}
            </article>
          </section>
          <div className="wt-modal-bottom-sec" style={{ position: "relative" }}>
            <p className="wt-modal-light-text">
              {/* project */}
              {t("PROJECT")}
            </p>
            <p
              className="wt-space-content-text"
              style={{
                flexGrow: "1",
                cursor: "pointer",
                opacity: activeProjectDrop ? "60%" : "1",
              }}
              onClick={() => {
                const fg = activeProjectDrop;
                setShowTypeDrop(false);
                setActiveProjectDrop(!fg);
                setActiveTaskDrop(false);
              }}
            >
              {/* {data?.projectName || "Select a Project"} */}
              {data?.projectName || t("Select a Project")}
            </p>
            {activeProjectDrop && (
              <section
                className={
                  screenSize === "xs"
                    ? "wt-modal-project-drop-mobile"
                    : "wt-modal-project-drop px-0"
                }
              >
                <section className="wt-modal-search ms-3">
                  <img
                    src={searchicon}
                    alt="Search Icon"
                    style={{ flexShrink: "0", width: "17px", height: "17px" }}
                  />
                  <input
                    className="quote-modal-input w-100"
                    placeholder="Search..."
                    value={projectSearch}
                    onChange={(e) => setProjectSearch(e.target.value)}
                  />
                </section>
                <section className="wt-modal-list gap-0">
                  {projects?.map((project) => {
                    return (
                      <p
                        className="choose-project ulterDrop"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          let dataAltered = data;
                          if (project?.projectid !== data?.projectId) {
                            delete dataAltered.taskid;
                            delete dataAltered.taskname;
                          }
                          setData({
                            ...dataAltered,
                            projectId: project?.projectid || "",
                            projectName: project?.projectname || "",
                          });
                          setActiveProjectDrop(false);
                          setTypeInScreen("asc");
                        }}
                      >
                        {project?.projectname || ""}
                      </p>
                    );
                  })}
                </section>
              </section>
            )}
          </div>
          <div className="wt-modal-bottom-sec" style={{ position: "relative" }}>
            <p className="wt-modal-light-text">
              {/* task */}
              {t("Task")}
            </p>
            <p
              className="wt-space-content-text"
              style={{
                flexGrow: "1",
                cursor: "pointer",
                opacity: activeTaskDrop ? "60%" : "1",
              }}
              onClick={() => {
                const fg = activeTaskDrop;
                setShowTypeDrop(false);
                setActiveProjectDrop(false);
                setActiveTaskDrop(!fg);
              }}
            >
              {data?.taskname || "Select a Task"}
            </p>
            {activeTaskDrop && (
              <section
                className={
                  screenSize === "xs"
                    ? "wt-modal-project-drop-mobile"
                    : "wt-modal-project-drop px-0"
                }
              >
                <section className="wt-modal-search ms-3">
                  <img
                    src={searchicon}
                    alt="Search Icon"
                    style={{ flexShrink: "0", width: "17px", height: "17px" }}
                  />
                  <input
                    className="quote-modal-input w-100"
                    placeholder="Search..."
                    value={taskSearch}
                    // onChange={(e) => setTaskSearch(e.target.value)}
                    onChange={searchTask}
                  />
                </section>
                <section className="wt-modal-list gap-0">
                  {tasks?.map((task) => {
                    return (
                      <p
                        className="choose-project ulterDrop"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setData({
                            ...data,
                            taskid: task?.taskid || "",
                            taskname: task?.taskname,
                          });
                          setActiveTaskDrop(false);
                          setTypeInScreen("asc");
                        }}
                      >
                        {task?.taskname || ""}
                      </p>
                    );
                  })}
                </section>
              </section>
            )}
          </div>
          {screenSize === "xs" ? (
            <div
              className="wt-modal-bottom-sec pe-1"
              style={{ position: "relative" }}
            >
              <p className="wt-modal-light-text">
                {/* time span */}
                {t("TIME SPAN")}
              </p>
              <section className="frc wt-modal-time-mobile gap-1">
                <article className="frc" style={{ gap: "4px" }}>
                  <img
                    alt=""
                    src={Calendar2}
                    style={{ width: "18px", height: "20px" }}
                  />
                  {/* <p className="wt-modal-cal-text">25.04.2023</p> */}
                  <AppDatePicker
                    selected={day}
                    isDisabledForFuture={true}
                    onChange={setDay}
                    dateFormat="dd/MM/yyyy"
                    onSelect={(d, event) => event.preventDefault()}
                    placeholderText={"00/00/0000"}
                  />
                </article>
                <div style={{ width: "70%" }}>
                  <article className="frc" style={{ gap: "5px" }}>
                    <img
                      alt=""
                      src={Clock}
                      style={{ width: "15px", height: "15px" }}
                    />
                    <p className="wt-modal-light-text">from</p>
                    <div className="frc">
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={fromHour}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 23
                          ) {
                            setFromHour(inputValue);
                          } else {
                            setFromHour("00");
                          }
                        }}
                      />
                      <p className="wt-modal-light-text">:</p>
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={fromMinute}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 59
                          ) {
                            setFromMinute(inputValue);
                          } else {
                            setFromMinute("00");
                          }
                        }}
                      />
                    </div>

                    <p className="wt-modal-light-text">to</p>
                    <div className="frc">
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={toHour}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 23
                          ) {
                            setToHour(inputValue);
                          } else {
                            setToHour("00");
                          }
                        }}
                      />
                      <p className="wt-modal-light-text">:</p>
                      {/*  const disabled = handleCheckHours(i) */}
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={toMinute}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value, 10);
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= 59
                          ) {
                            setToMinute(inputValue);
                          } else {
                            setToMinute("00");
                          }
                        }}
                      />
                    </div>
                  </article>

                  <article className="frc" style={{ gap: "10px" }}>
                    <img
                      alt=""
                      src={Clock}
                      style={{ width: "17px", height: "17px" }}
                    />
                    <p className="wt-modal-light-text">total</p>
                    <div className="frc">
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={totalHour}
                      />
                      <p className="wt-modal-light-text">:</p>
                      <input
                        className="wt-modal-time-input total-color"
                        type="number"
                        placeholder="00"
                        value={totalMinute}
                      />
                    </div>
                  </article>
                </div>
              </section>
            </div>
          ) : (
            <div
              className="wt-modal-bottom-sec pe-1"
              style={{ position: "relative" }}
            >
              <p className="wt-modal-light-text">
                {/* time span */}
                {t("TIME SPAN")}
              </p>
              <section className="frc wt-modal-time gap-1">
                <article
                  className="frc"
                  style={{ gap: "5px", minWidth: "107px" }}
                >
                  <img
                    alt=""
                    src={Calendar2}
                    style={{ width: "21px", height: "22px" }}
                    onClick={() => setCalendarIsOpen((p) => !p)}
                  />
                  {/* <p className="wt-modal-cal-text">25.04.2023</p> */}
                  <AppDatePicker
                    open={calendarIsOpen}
                    onOpenChange={(open) => setCalendarIsOpen(open)}
                    selected={day}
                    isDisabledForFuture={true}
                    onChange={setDay}
                    dateFormat="dd/MM/yyyy"
                    onSelect={(d, event) => {
                      setDateError(false);
                      event.preventDefault();
                    }}
                    placeholderText={"00/00/0000"}
                    isError={dateError}
                    error={setDateError}
                  />
                </article>

                <article className="frc" style={{ gap: "5px" }}>
                  <img
                    alt=""
                    src={Clock}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <p className="wt-modal-light-text">from</p>
                  <div className="frc" style={{ minWidth: "60px" }}>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      value={fromHour}
                      maxLength="2"
                      id="hoursInput"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 23
                        ) {
                          setFromHour(value || "00");
                          if (value.length === 2) {
                            document.getElementById("minutesInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setFromHour((prevHours) =>
                            prevHours.slice(0, prevHours.length - 1),
                          );
                        }
                      }}
                    />
                    <p className="wt-modal-light-text">:</p>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      id="minutesInput"
                      maxLength="2"
                      value={fromMinute}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 59
                        ) {
                          setFromMinute(value || "00");
                          if (value.length === 0 && fromHour.length > 0) {
                            document.getElementById("hoursInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setFromMinute((prevMinutes) =>
                            prevMinutes.slice(0, prevMinutes.length - 1),
                          );
                        }
                      }}
                    />
                  </div>

                  <p className="wt-modal-light-text">to</p>
                  <div className="frc" style={{ minWidth: "60px" }}>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      value={toHour}
                      maxLength="2"
                      id="hoursToInput"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 23
                        ) {
                          setToHour(value || "00");
                          if (value.length === 2) {
                            document.getElementById("minutesToInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setToHour((prevHours) =>
                            prevHours.slice(0, prevHours.length - 1),
                          );
                        }
                      }}
                    />
                    <p className="wt-modal-light-text">:</p>
                    <input
                      className="wt-modal-time-input total-color"
                      type="number"
                      placeholder="00"
                      id="minutesToInput"
                      maxLength="2"
                      value={toMinute}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d+$/.test(value) &&
                          +value >= 0 &&
                          +value <= 59
                        ) {
                          setToMinute(value || "00");
                          if (value.length === 0 && toHour.length > 0) {
                            document.getElementById("hoursToInput").focus();
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          setToMinute((prevMinutes) =>
                            prevMinutes.slice(0, prevMinutes.length - 1),
                          );
                        }
                      }}
                    />
                  </div>
                </article>

                <article className="frc" style={{ gap: "5px" }}>
                  <img
                    alt=""
                    src={Clock}
                    style={{ width: "17px", height: "17px" }}
                  />
                  <p className="wt-modal-light-text">total</p>
                  <div className="frc" style={{ minWidth: "60px" }}>
                    <input
                      style={{ width: "100%" }}
                      className="wt-modal-time-input total-color"
                      placeholder="00:00"
                      value={total}
                    />
                  </div>
                </article>
              </section>
            </div>
          )}
          <section className="wt-modal-bottom-sec"></section>
          <section className="wt-modal-bottom-sec">
            <p className="wt-modal-light-text">
              {/* description */}
              {t("DESCRIPTION")}
            </p>
            <textarea
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setTypeInScreen("asc");
              }}
              // placeholder="A brief description of the task you performed"
              placeholder={t("A brief Description of the task you performed")}
              className="wt-modal-description"
            />
          </section>
          {screenSize === "xs" ? (
            <section className="wt-modal-btns">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: "5px",
                  marginLeft: "20px",
                }}
              >
                <button
                  type="button"
                  className="addProCancel wt-cancel-btn"
                  style={{ width: "100%", height: "50px" }}
                  onClick={handleCancelModal}
                >
                  {/* Cancel */}
                  {t("Cancel")}
                </button>
                <button
                  disabled={isSubmitDisabled}
                  style={{
                    width: "100%",
                    height: "50px",
                    cursor: isSubmitDisabled ? "not-allowed" : "pointer",
                  }}
                  type="button"
                  onClick={handleAddManualTime}
                  className="wt-add-btn"
                >
                  {loading ? (
                    <div className="gap-1 d-flex justify-content-center align-items-center">
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      ></div>
                      <span>{isEdit ? "Updating..." : "Adding..."}</span>
                    </div>
                  ) : isEdit ? (
                    t("Update") // update
                  ) : (
                    t("Add ") // add
                  )}
                </button>
              </div>
            </section>
          ) : (
            <section className="wt-modal-btns">
              <p style={{ minWidth: "60px" }}></p>
              <button
                type="button"
                className="addProCancel wt-cancel-btn"
                // onClick={handleCancelModal}
                onClick={() => {
                  if (typeInScreen !== "") {
                    setCancelPopupShow(true);
                  } else {
                    setShowModal(false);
                  }
                  handleCancelModal();
                }}
              >
                {/* Cancel */}
                {t("Cancel")}
              </button>
              <button
                disabled={isSubmitDisabled}
                style={{ cursor: isSubmitDisabled ? "not-allowed" : "pointer" }}
                type="button"
                onClick={handleAddManualTime}
                className="wt-add-btn"
              >
                {loading ? (
                  <div className="gap-1 d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></div>
                    <span>{isEdit ? "Updating..." : "Adding..."}</span>
                  </div>
                ) : isEdit ? (
                  // "Update"
                  t("Update") // update
                ) : (
                  t("Add ") //add
                )}
              </button>
            </section>
          )}
        </div>
      </div>

      <Modal
        show={conflict?.isConflict}
        className="modelwidthWorkTime modal-dialog1"
        style={{
          backgroundColor: "transparent",
          opacity: 1,
        }}
        id="worktime-member-modal"
        centered
      >
        <Modal.Body style={{ backgroundColor: "#D2DCE9" }}>
          <div className="flex_class my-5">
            <div style={{ color: "#1A3A79", fontWeight: "bold" }}>
              {/* The time span overlaps existing time tracked. */}
              {t("The time span overlaps existing time tracked.")}
            </div>

            <div className="">
              {/* Please introduce a new time span. */}
              {t("Please introduce a new time span.")}
            </div>

            <div className="mt-5 ">
              <button
                className="ms-2 w-25 btn-yes"
                onClick={() => {
                  setConflict({ isConflict: false, conflictMessage: "" });
                }}
              >
                {/* Ok */}
                {t("Ok")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
